module.exports = __webpack_public_path__ + "assets/adpoly-facility-admin-offices-bulk-upload-template.d61a4cf2.xlsx";